module.exports = __webpack_public_path__ + "loader.svg?98e076eca46c2c2e5073b28c5d17b729";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loader.svg
// module id = 16
// module chunks = 188